import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      // The passport is a one-shot public read; a 404 (unknown/disabled token)
      // should surface immediately rather than retrying.
      retry: false,
    },
  },
});
